module.exports = __webpack_public_path__ + "img/des-7.6f25b9b4.jpg";